import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { IdleService } from 'src/app/core/services/idle.service';
// import Swal from 'sweetalert2/dist/sweetalert2.js';

@Injectable()
export class HttpErrorInterceptorService implements HttpInterceptor {

  constructor(
    private toastr: ToastrService,
    private injector: Injector
  ) {

  }

  /**
   * IdleService is resolved on use, not injected: it ends an expired session by
   * calling the logout endpoint, which runs through this interceptor, and it can
   * do that from its own constructor (the session is checked at app load).
   */
  private endExpiredSession(): void {
    this.injector.get(IdleService).handleSessionExpired();
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 0) {
            // Network / CORS error — no response from server
            this.toastr.error('Whoops! Something went wrong, Try again later');
          } else if (error.status === 401 || error.error?.status_code === 401) {
            // The server no longer accepts the session (expired cookie, revoked
            // token) — end it: toast, server logout, disconnect wallet, login page.
            this.endExpiredSession();
          } else if (error.status === 403 && String(error.error?.message || '').toLowerCase().includes('csrf')) {
            // Stale/missing CSRF token — treat like an expired session
            this.endExpiredSession();
          } else {
            // All other HTTP errors
            const message = error.error?.message || error.message || 'An unexpected error occurred';
            this.toastr.error(message);
          }
          // Always re-throw so individual callers can react if needed
          return throwError(() => error);
        })
      );
  }
}
